
<form [formGroup]="processService.form" class="process-form-field" (submit)='addProcessTab()'>
  <mat-form-field style="margin-left: 20px;">
    <input matInput type="text" formControlName="processName" placeholder="Enter Process Name" required>
    <mat-error *ngIf="processService.form.controls['processName'].errors?.required">Name Field Is Mandatory.</mat-error>
    <mat-error *ngIf="processService.form.controls['processName'].errors?.minLength">Minimum two characters needed.
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <input formControlName="startDate" matInput [matDatetimepicker]="picker" placeholder="Start Date" [min]="minDate"  required
      autocomplete="false">
    <mat-datetimepicker-toggle [for]="picker" matSuffix></mat-datetimepicker-toggle>
    <mat-datetimepicker #picker type="datetime" openOnFocus="true" timeInterval="5"></mat-datetimepicker>
  </mat-form-field>                      

  <mat-form-field>
    <input formControlName="endDate" matInput [matDatetimepicker]="picker1" placeholder="End Date" [min]="minDate" required
      autocomplete="false">  
    <mat-datetimepicker-toggle [for]="picker1" matSuffix></mat-datetimepicker-toggle>
      <mat-datetimepicker #picker1 type="datetime" openOnFocus="true" timeInterval="5"></mat-datetimepicker>
      <mat-error *ngIf="processService.form.hasError('invalidDate')">Process end date should be greater than start date.</mat-error>
    </mat-form-field>
  
  <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)='onClear()'>
    <mat-icon>close</mat-icon>
  </button>

  <button mat-raised-button class="add-create-button" #selectAfterAdding color="primary" type="submit"
    [disabled]="processService.form.invalid"> {{processButton}}
  </button>
</form>

<mat-tab-group class="tab-header-back" dynamicHeight="true" [selectedIndex]="selectedIndex" (selectedIndexChange)="selected.setValue($event)" (selectedTabChange)="eventTabClick($event)">

  <mat-tab *ngFor="let process of processes; let index = processId">
    <ng-template mat-tab-label>
      <div  matTooltip="Timing: {{process.startDate}} to {{process.endDate}}"
        matTooltipPosition="above"
        class="hideOverflowContent"
        style="text-overflow: ellipsis; padding-left: 10px; cursor: pointer"
        >
        {{process.processName}}
      </div>
    </ng-template>
    
      <div style="background-color: #fafafa;">
        <div class="top-header-cards" style="margin-left: -8px;">
          <mat-card class="process-header-card process-header-align">
            <h3 style="font-size: 20px; margin-top: 11px; text-overflow: ellipsis; cursor: pointer"
              class="processOverflowContent"
              matTooltip="{{process.processName}}"
              matTooltipPosition="below"
            >
              {{process.processName}}
            </h3>
            <div>
              <button [disabled]="process.processSeq === 1 ? true : false" mat-icon-button  
              (click)="removeProcessTab(process.processId)">
                <mat-icon matTooltip="Delete Process" style="font-size: 30px;">delete_outline</mat-icon>
              </button>
              <button  mat-icon-button (click)="onEditProcess(process.processId)">
                <mat-icon matTooltip="Edit Process" style="font-size: 30px;">edit</mat-icon>
              </button>
            </div>
          </mat-card>
          <mat-card class="panel-header-card process-header-align">
            <h3>Room List</h3>
            <div>
              <button mat-icon-button [disabled]="panelLengthArray !== null ? true : false" (click)="onAutoPanelCreation(process.processId)">
              <mat-icon [matTooltip] = "panelLengthArray !== null ? 'Auto Room Creation can be used initially' : 'Auto Room Creation'" style="margin-right: 20px; cursor: pointer; font-size: 30px ">post_add</mat-icon> 
            </button>
            <button mat-icon-button>
              <mat-icon matTooltip= "Create Room" style="margin-right: 10px; cursor: pointer; font-size: 30px" (click)= "onPanelCreate(process.processId)">add_circle_outline</mat-icon> 
            </button>
            </div>
          
            </mat-card>
        </div>
        
        <div class="bottom-details-cards" style="margin-left: -8px;">
          <mat-card class="process-content-card">
            <table class="process-table-content">
              <tr [matTooltip]="getToolTipData(process.processId)" class="process-table-row-content">
                <td> &#x267C; Total Shortlisted Candidates:</td>
                <td><b>{{shortListedMap.get(process.processId)}}</b></td>
              </tr>

              <tr class="process-table-row-content">
                <td> &#x267C; Total Assigned Candidates:</td>
                <td ><b>{{totalAssignedPerProcess}}</b></td>
              </tr>

              <tr class="process-table-row-content">
                <td> &#x267C; Rest Candidates in Queue: </td>
                <td ><b>{{shortListedMap.get(process.processId)-totalAssignedPerProcess}}</b></td>
              </tr>

              <tr class="process-table-row-content">
                <td> &#x267C; Total Selected Candidates:</td>
                <td ><b>{{selectedCandidates}}</b></td>
              </tr>

              <tr class="process-table-row-content">
                <td> &#x267C; Total Rejected Candidates:</td>
                <td ><b>{{rejectedCandidates}}</b></td>
              </tr>

              <tr class="process-table-row-content">
                <td> &#x267C; Timing:</td>
                <td>
                  <b>
                  <span style="float: right;" > {{process.startDate}} </span> <br />
                    <span > -to-  {{process.endDate}} </span>
                  </b>
                </td>
              </tr>
            </table>

          </mat-card>

          <mat-card class="panel-content-card">
            <mat-card class="panel-card panel-card-content" *ngFor="let panel of allPanels; let index = index">
              <mat-card-title class="process-header-align">
                {{panel.panelName}}
                <div>
                  <button mat-icon-button (click)="onEditPanel(process.processId, panel.panelId)">
                    <mat-icon matTooltip="Edit" style="margin-bottom: 15px;">edit</mat-icon>
                  </button>
                  <button mat-icon-button [disabled]="panelInProcessMap.get(panel.panelId)" 
                          (click)="removePanel(panel.panelId)">
                    <mat-icon matTooltip="Delete" style="margin-bottom: 15px;">delete_outline</mat-icon>
                  </button>
                  <button mat-icon-button (click)="panelAssign(panel.panelId)">
                    <mat-icon matTooltip="Send Mail to Candidates and Panel Members" style="margin-bottom: 15px;">mail</mat-icon>
                  </button>

                  <button mat-icon-button><mat-icon matTooltip="More Options" style="cursor: pointer; margin-bottom: 15px;"  [matMenuTriggerFor]="menu">more_vert</mat-icon></button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item (click)= "addMoreCandidate(panel.panelId,process.processId)">Add Candidates</button> 
                      <!-- <button mat-menu-item (click)= "panelMemberListModal(panel.panelId,process.processId)">Add Panel Member ??</button>  -->
                      <button mat-menu-item (click)="openAssignedCandidates(panel.panelId)">Panel Details</button> 
                    </mat-menu>
                </div>
              </mat-card-title>
              <mat-card-content>
                <table style="font-size: 15px; line-height: 2;">
                  <tr>
                    <td style="text-align: left;"> Assigned Candidates:</td>
                    <td style="color: blue; float: right"><b>{{panel.assignedCnt}}</b></td>
                  </tr>
                  
                  <!-- <tr>
                    <td style="text-align: left;"> Assigned PanelMembers:</td>
                    <td style="color: blue;"><b></b></td>
                  </tr> -->

                  <tr>
                    <td style="text-align: left;">Selected Candidates:</td>
                    <td style="color: green; float: right"><b>{{panel.selectedCnt}}</b></td>
                  </tr>

                  <tr>
                    <td style="text-align: left;"> Rejected Candidates:</td>
                    <td style="color: red; float: right;"><b>{{panel.rejectedCnt}}</b></td>
                  </tr>
                </table>
              </mat-card-content>
              
              <mat-card-actions *ngIf= "panel.assignedCnt != (panel.selectedCnt + panel. rejectedCnt)">
                      
                <span class = "panel-not-started" *ngIf = "panelNotYetStartedMap.get(panel.panelId)">...Yet to start</span>
                <span class = "panel-in-progress" *ngIf = "panelInProcessMap.get(panel.panelId)">...In progress</span>
                
              </mat-card-actions>
              <div class="panel-footer" *ngIf="panel.assignedCnt == (panel.selectedCnt + panel. rejectedCnt)">
                <span>Panel Completed</span>
              </div>
            
            </mat-card>
        </mat-card>
          
        </div>
        
      </div>
    
    
<!--     
    
    <div class="process-panels tab-back">
      <div class=" mat-elevation-z4">
        <mat-card class="process-card-header process-header-align">
          <h3 style="font-size: 20px; margin-top: 11px; ">{{process.processName}}</h3>
          <div>
            <button [disabled]="process.processSeq === 1 ? true : false" mat-icon-button  
            (click)="removeProcessTab(process.processId)">
              <mat-icon matTooltip="Delete Process" style="font-size: 30px; margin-top: 10px">delete_outline</mat-icon>
            </button>
            <button  mat-icon-button (click)="onEditProcess(process.processId)">
              <mat-icon matTooltip="Edit Process" style="font-size: 30px; margin-top: 10px">edit</mat-icon>
            </button>
          </div>
        </mat-card>
        <mat-card class="panel-form-box">
          <table>
            <tr [matTooltip]="getToolTipData(process.processId)">
              <td> &#x267C; Total Sort-Listed Candidates:</td>
              <td ><b>{{shortListedMap.get(process.processId)}}</b></td>
            </tr>

            <tr>
              <td> &#x267C; Total Assigned Candidates:</td>
              <td style="float: right;"><b>{{totalAssignedPerProcess}}</b></td>
            </tr>

            <tr>
              <td> &#x267C; Rest Candidates in Queue: </td>
              <td style="float: right;"><b>{{shortListedMap.get(process.processId)-totalAssignedPerProcess}}</b></td>
            </tr>

            <tr>
              <td> &#x267C; Total Selected Candidates:</td>
              <td style="float: right;"><b>{{selectedCandidates}}</b></td>
            </tr>

            <tr>
              <td> &#x267C; Total Rejected Candidates:</td>
              <td style="float: right;"><b>{{rejectedCandidates}}</b></td>
            </tr>

            <tr>
              <td>Timing:</td>
              <td>
                <b>
                 <span style="float: right;"> {{process.startDate}} </span> <br />
                   <span> -to-  {{process.endDate}} </span>
                 </b>
              </td>
            </tr>
          </table>

        </mat-card>
      </div>

      <div class="process-content-align">
        
        <mat-card class="panel-header-card process-header-align">
          <h3>Room List</h3>
          <div>
            <mat-icon matTooltip= "Auto Panel Creation" style="margin-right: 20px; cursor: pointer; font-size: 30px " (click)="onAutoPanelCreation(process.processId)">post_add</mat-icon> 
            <mat-icon matTooltip= "Create Room" style="margin-right: 10px; cursor: pointer; font-size: 30px" (click)= "onPanelCreate(process.processId)">add_circle_outline</mat-icon> 
          </div>
        </mat-card>

        <mat-card class="blocksWrapper">
            <mat-card class="panel-card panel-card-content" *ngFor="let panel of allPanels; let index = index">
              <mat-card-title class="process-header-align">
                {{panel.panelName}}
                <div>
                  <button mat-icon-button (click)="onEditPanel(process.processId, panel.panelId)">
                    <mat-icon matTooltip="Edit" style="margin-bottom: 15px;">edit</mat-icon>
                  </button>
                  <button mat-icon-button [disabled]="panelInProcessMap.get(panel.panelId)" 
                          (click)="removePanel(panel.panelId)">
                    <mat-icon matTooltip="Delete" style="margin-bottom: 15px;">delete_outline</mat-icon>
                  </button>
                  <button mat-icon-button (click)="panelAssign(panel.panelId)">
                    <mat-icon matTooltip="Send Mail to Candidates and Panel Members" style="margin-bottom: 15px;">mail</mat-icon>
                  </button>

                  <button mat-icon-button><mat-icon matTooltip="More Options" style="cursor: pointer; margin-bottom: 15px;"  [matMenuTriggerFor]="menu">more_vert</mat-icon></button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item (click)= "addMoreCandidate(panel.panelId,process.processId)">Add Candidates</button> 
                      <button mat-menu-item (click)= "panelMemberListModal(panel.panelId,process.processId)">Add Panel Member</button> 
                      <button mat-menu-item (click)="openAssignedCandidates(panel.panelId)">Send Notification to Candidates</button> 
                    </mat-menu>
                </div>
              </mat-card-title>
              <mat-card-content>
                <table style="font-size: 15px; line-height: 2;">
                  <tr>
                    <td style="text-align: left;"> Assigned Candidates:</td>
                    <td style="color: blue;"><b>{{panel.assignedCnt}}</b></td>
                  </tr>
                  
                  <tr>
                    <td style="text-align: left;"> Assigned PanelMembers:</td>
                    <td style="color: blue;"><b></b></td>
                  </tr>

                  <tr>
                    <td style="text-align: left;">Selected Candidate:</td>
                    <td style="color: green;"><b>{{panel.selectedCnt}}</b></td>
                  </tr>

                  <tr>
                    <td style="text-align: left;"> Rejected Candidate:</td>
                    <td style="color: red;"><b>{{panel.rejectedCnt}}</b></td>
                  </tr>
                </table>
              </mat-card-content>
              
              <mat-card-actions *ngIf= "panel.assignedCnt != (panel.selectedCnt + panel. rejectedCnt)">
                      
                <span class = "panel-not-started" *ngIf = "panelNotYetStartedMap.get(panel.panelId)">...Yet to start</span>
                <span class = "panel-in-progress" *ngIf = "panelInProcessMap.get(panel.panelId)">...In progress</span>
                
              </mat-card-actions>
              <div class="panel-footer" *ngIf="panel.assignedCnt == (panel.selectedCnt + panel. rejectedCnt)">
                <span>Panel Completed</span>
              </div>
            
            </mat-card>
        </mat-card>
      </div>

    </div> -->
  </mat-tab>
</mat-tab-group> 









  

 <!-- <form [formGroup]="processService.form" class="process-form-field" (submit)='addProcessTab()'>
  <mat-form-field>
    <input matInput type="text" formControlName="processName" placeholder="Enter Process Name" required>
    <mat-error *ngIf="processService.form.controls['processName'].errors?.required">Name Field Is Mandatory.</mat-error>
    <mat-error *ngIf="processService.form.controls['processName'].errors?.minLength">Minimum two characters needed.
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <input formControlName="startDate" matInput [matDatetimepicker]="picker" placeholder="Start Date" required
      autocomplete="false">
    <mat-datetimepicker-toggle [for]="picker" matSuffix></mat-datetimepicker-toggle>
    <mat-datetimepicker #picker type="datetime" openOnFocus="true" timeInterval="5"></mat-datetimepicker>
   
  </mat-form-field>                      

  <mat-form-field>
    <input formControlName="endDate" matInput [matDatetimepicker]="picker1" placeholder="End Date" required
      autocomplete="false"> 
    <mat-datetimepicker-toggle [for]="picker1" matSuffix></mat-datetimepicker-toggle>
      <mat-datetimepicker #picker1 type="datetime" openOnFocus="true" timeInterval="5"></mat-datetimepicker>
      <mat-error *ngIf="processService.form.hasError('invalidDate')">Process end date should be grater then start date.</mat-error>
    </mat-form-field>
  
  <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)='onClear()'>
    <mat-icon>close</mat-icon>
  </button>

  <button mat-raised-button class="add-create-button" #selectAfterAdding color="primary" type="submit"
    [disabled]="processService.form.invalid"> {{processButton}}
  </button>
</form>

<mat-tab-group dynamicHeight="true" [selectedIndex]="selected.value" (selectedIndexChange)="selected.setValue($event)" (selectedTabChange)="eventTabClick($event)">

  <mat-tab *ngFor="let process of processes; let index = processId">
    <ng-template mat-tab-label>
      <div  matTooltip="Timing: {{process.startDate}} -to- {{process.endDate}}"
        matTooltipPosition="above">
        {{process.processName}}
      </div>
    </ng-template>

    <div class="process-list">
      <div class="process-card mat-elevation-z4">
        <mat-card-title>
          <button [disabled]="process.processSeq === 1 ? true : false" mat-icon-button class="deletetHover" 
          (click)="removeProcessTab(process.processId)">
            <mat-icon>delete_outline</mat-icon>
          </button>
          <span matBadge="{{process.processSeq}}" matBadgeOverlap="false">{{process.processName}}</span>
          <button mat-icon-button class="submitHover" (click)="onEditProcess(process.processId)">
            <mat-icon>edit</mat-icon>
          </button>
        </mat-card-title>
        <p class="process-time">Timing: {{process.startDate}} -to- {{process.endDate}}</p>
        <mat-card-content>
          <table>
            <tr [matTooltip]="getToolTipData(process.processId)" style="color: blue;">
              <td> &#x267C; Total Sort-Listed Candidates:</td>
              <td><b>{{shortListedMap.get(process.processId)}}</b></td>
            </tr>

            <tr style="color: darkturquoise;">
              <td> &#x267C; Total Assigned Candidates:</td>
              <td><b>{{totalAssignedPerProcess}}</b></td>
            </tr>

            <tr style="color: maroon;">
              <td> &#x267C; Rest Candidates in Queue: </td>
              <td><b>{{shortListedMap.get(process.processId)-totalAssignedPerProcess}}</b></td>
            </tr>

            <tr style="color: green;">
              <td> &#x267C; Total Selected Candidates:</td>
              <td><b>{{selectedCandidates}}</b></td>
            </tr>

            <tr style="color: red;">
              <td> &#x267C; Total Rejected Candidates:</td>
              <td><b>{{rejectedCandidates}}</b></td>
            </tr>
          </table>
        </mat-card-content>
        <mat-card-actions>
          <button mat-button class="submitHover" [disabled]="!autoPanelShowHide"
            (click)="onAutoPanelCreation(process.processId)">Auto Panel
            Creation</button>
        </mat-card-actions>
      </div>
    </div>

    <div class="process-panels">
      <div class="panel-form-box mat-elevation-z4">
        <mat-card-title>
          {{process.processName}}
        </mat-card-title>
        <form [formGroup]="panelService.form" class="panel-form" (submit)='onSubmitPanelCreation(process.processId)'>
          <mat-card-title>Enter Panel Details</mat-card-title>

          <mat-form-field>
            <input formControlName="panelName" matInput placeholder="Panel Name" required>
            <mat-error *ngIf="panelService.form.controls['panelName'].errors?.required">Panel Name cannot be null, minimum 1 Charachter needed.
            </mat-error>
          </mat-form-field>

          <mat-form-field>
            <input formControlName="roomIdentification" matInput placeholder="Room Identification" required>
            <mat-error *ngIf="panelService.form.controls['roomIdentification'].errors?.required">Room Identification
              cannot be null, minimum 1 Charachter needed.</mat-error>
          </mat-form-field>

          <mat-form-field>
            <input formControlName="panelMembers" matInput placeholder="Choose Panel Members" required>
            <button type="button" mat-button matSuffix mat-icon-button
              (click)="panelMemberListModal(process.processId)">
              <mat-icon>contacts</mat-icon>
            </button>
            <mat-error *ngIf="panelService.form.controls['panelMembers'].errors?.required">Panel Member
              cannot be null, minimum 1 panel member needed.</mat-error>
          </mat-form-field>

          <mat-form-field>
            <input formControlName="candidates" matInput placeholder="Choose Candidates">
            <button type="button" mat-button matSuffix mat-icon-button (click)="candidateListModal(process.processId)">
              <mat-icon>contacts</mat-icon>
            </button>
          </mat-form-field>

          <div class="button-row">
            <button mat-flat-button color="warn" (click)="clearPanelForm()">Clear</button>
            <button mat-flat-button color="primary" type="submit" [disabled]="panelService.form.invalid">{{panelButton}}</button>
          </div>
        </form>
      </div>

      <div class="panel-box-list mat-elevation-z4">
        <mat-card-title>Panel List</mat-card-title>
        <div class="panel-list-queue">Candidates in Queue:
          <b>{{shortListedMap.get(process.processId)-totalAssignedPerProcess}}</b>
        </div>
        <mat-grid-list cols="3" rowHeight="200px" gutterSize="5px">
          <mat-grid-tile *ngFor="let panel of allPanels; let index = index">
            <mat-card class="panel-card">
              <mat-card-title>
                {{panel.panelName}}
                <span class = "panel-not-started" *ngIf = "panelNotYetStartedMap.get(panel.panelId)">..Yet to start</span>
                <span class = "panel-in-progress" *ngIf = "panelInProcessMap.get(panel.panelId)">..In progress</span>
              </mat-card-title>
              <mat-card-content>
                <table style="font-size: 99%;">
                  <tr style="color: blue;">
                    <td><a (click)="openAssignedCandidates(panel.panelId)"> Assigned Candidates:</a></td>
                    <td><b>{{panel.assignedCnt}}</b></td>
                    <button mat-icon-button (click)="addMoreCandidate(panel.panelId,process.processId)" matTooltip= "Add more candidates" matTooltipPosition="above">
                      <mat-icon>group_add</mat-icon>
                    </button>
                  </tr>

                  <tr style="color: green;">
                    <td><a> Selected Candidate:</a></td>
                    <td><b>{{panel.selectedCnt}}</b></td>
                  </tr>

                  <tr style="color: red;">
                    <td><a> Rejected Candidate:</a></td>
                    <td><b>{{panel.rejectedCnt}}</b></td>
                  </tr>
                </table>
              </mat-card-content>
              <mat-card-actions *ngIf= "panel.assignedCnt != (panel.selectedCnt + panel. rejectedCnt)">
                <button mat-icon-button class="submitHover" (click)="onEditPanel(panel.panelId)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button class="deletetHover" [disabled]="panelInProcessMap.get(panel.panelId)" 
                        (click)="removePanel(panel.panelId)">
                  <mat-icon>delete_outline</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="panelAssign(panel.panelId)" matTooltip= "Send mail to panelMember">
                  <mat-icon>mail</mat-icon>
                </button>
              </mat-card-actions>
              <div class="panel-footer" *ngIf="panel.assignedCnt == (panel.selectedCnt + panel. rejectedCnt)">
                <span>Panel Completed</span>
              </div>
            </mat-card>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
    </div>
    <div class="button-row">

    </div>
  </mat-tab>
</mat-tab-group> -->